import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  flatListContainer: {
    padding: 10,
  },
  tierContentContainer: { borderRadius: 10, marginTop: 10, padding: 20, paddingLeft: 0 },
  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
  },
  whiteDash: {
    width: "100%",
    borderWidth: 1,
    borderColor: "white",
    borderStyle: "dashed",
  },
  columnWrapper: { justifyContent: "space-between" },
  container: { height: "100%" },
  contentContainer: {
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: 20,
    padding: 1,
    width: "48%",
  },
  voucherContainer: {
    borderRadius: 10,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOpacity: 0.3,
    shadowRadius: 6,
    marginTop: 20,
    padding: 15,
    elevation: 8,
    overflow: "hidden",
    marginHorizontal: 5,
    shadowOffset: {
      width: 0,
      height: 0,
    },
  },
  row: { alignItems: "center", flexDirection: "row" },
  text: { color: colors.black, fontFamily: typography.primary.normal, marginLeft: 20 },
  dividerView: {
    borderColor: colors.lightGrey,
    borderRadius: 1,
    borderStyle: "dashed",
    borderWidth: 1,
    height: 1,
    marginVertical: 10,
    width: "100%",
    zIndex: 1,
  },
  dividerViewStyle: {
    backgroundColor: colors.white,
    bottom: 0,
    height: 1,
    left: 0,
    position: "absolute",
    width: "100%",
    zIndex: 1,
  },
  voucherDescription: {
    color: colors.darkerGrey,
    fontFamily: typography.primary.normal,
    fontSize: 12,
  },
  contentDescription: { fontFamily: typography.primary.normal, fontSize: 11 },
  contentTitleText: { marginTop: 10, paddingHorizontal: 20, width: "80%", textAlign: "center" },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  emptyTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
    textAlign: "center",
  },
  flatList: { paddingVertical: 20 },
  flex: { flex: 1 },
  headerLogoContainer: { flexDirection: "row", justifyContent: "space-around", width: 85 },
  headerTabBarContainer: {
    alignSelf: "center",
    borderColor: colors.white,
    borderRadius: 20,
    borderWidth: 2,
    flexDirection: "row",
    height: 30,
    width: "90%",
  },
  image: {
    width: 90, height: 90, alignSelf: "flex-end", borderRadius: 15,
  },
  imageTagContainer: {
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 1,
    position: "absolute",
    zIndex: 99,
  },
  itemTagText: { color: colors.white, fontSize: 14 },
  linearGradient: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10, paddingTop: 10 },
  selectedTabBar: {
    backgroundColor: colors.white,
    borderRadius: 30,
    margin: 1,
  },
  tabBar: { alignItems: "center", flex: 1, justifyContent: "center" },
})
